import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WorkingHoursFacade } from './working-hours.facade';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursItemGuard {
  constructor(private workingHoursFacade: WorkingHoursFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { workingHoursId },
    } = route;
    this.workingHoursFacade.loadWorkingHoursById(workingHoursId);

    return of(true);
  }

  canDeactivate(): boolean {
    this.workingHoursFacade.itemSetInitialState();

    return true;
  }
}
